import { LogicJumpActionType } from '@app/api';

interface Type {
  toFieldId?: string | null;
  type: LogicJumpActionType;
}

export const findJump = <T extends Type>(
  arr?: T[],
  jump?: Type,
): T | undefined => {
  if (!arr || !jump) {
    return undefined;
  }
  return arr.find((o) => isSameJumpDest(o, jump));
};

export const isSameJumpDest = (o: Type, jump: Type): boolean => {
  const oToFieldId = o.toFieldId || undefined;

  const jToFieldId = jump.toFieldId || undefined;
  return oToFieldId === jToFieldId && o.type === jump.type;
};
